import React from "react";
import { checkForOverride, glow, linearGradient } from "../helpers/theme";
import { ReplaceWithDataSource } from "../helpers/variable";

export default function ImageWithMessage({
	cue,
	isPreview,
	baseTheme,
	baseThemeId,
	cloud,
	mediaLocation,
}) {
	return (
		<>
			<span
				className={`${cue.type}
    ${
			(cue.status === "cued" && isPreview) ||
			cue.status === "onair" ||
			cue.status === "coming" ||
			(cue.status === "cuedoff" && !isPreview) ||
			cue.status === "going"
				? "opacity-100"
				: "opacity-0"
		}
    animated_${cue.animationName}_image_with_message_holder ${
					(cue.status === "cued" && isPreview) ||
					cue.status === "coming" ||
					cue.status === "onair" ||
					(cue.status === "cuedoff" && !isPreview)
						? `animated_${cue.animationName}_image_with_message_animate-in`
						: `animated_${cue.animationName}_image_with_message_animate-out`
				}

    
    
    
`}
			>
				{/* LARGE TEXT */}
				<span
					style={{
						fontFamily: baseTheme.h1?.font || baseTheme.font?.family,
						zIndex: "-1",
						color: checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"h1",
							"colour"
						),
						fontWeight:
							checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"h1",
								"bold"
							) === true
								? "bold"
								: "normal",
						fontStyle:
							checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"h1",
								"italic"
							) === true
								? "italic"
								: "normal",
						textDecoration:
							checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"h1",
								"underline"
							) === true
								? "underline"
								: "none",
						background: linearGradient(
							baseTheme,
							cue.type,
							cue.preset,
							"background",
							"colour"
						),
						boxShadow: glow(
							baseTheme,
							cue.type,
							cue.preset,
							"background",
							"glowBlur"
						),
						borderTop: `${
							checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"sides"
							)[0] === "1"
								? baseTheme.border.size
								: 0
						}vw ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"style"
						)} ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"colour"
						)}`,
						borderBottom: `${
							checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"sides"
							)[1] === "1"
								? baseTheme.border.size
								: 0
						}vw ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"style"
						)} ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"colour"
						)}`,
						borderLeft: `${
							checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"sides"
							)[2] === "1"
								? baseTheme.border.size
								: 0
						}vw ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"style"
						)} ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"colour"
						)}`,
						borderRight: `${
							checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"sides"
							)[3] === "1"
								? baseTheme.border.size
								: 0
						}vw ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"style"
						)} ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"colour"
						)}`,
					}}
					className={` key_me ${baseThemeId}_${
						cue.type
					}_large_text ${baseThemeId}_large_text large_text 
        animated_${cue.animationName}_image_with_message_small ${
						(cue.status === "cued" && isPreview) ||
						cue.status === "coming" ||
						cue.status === "onair" ||
						(cue.status === "cuedoff" && !isPreview)
							? `animated_${cue.animationName}_image_with_message_small-animate-in`
							: `animated_${cue.animationName}_image_with_message_small-animate-out`
					}

    px-${checkForOverride(
			baseTheme,
			cue.type,
			cue.preset,
			"background",
			"paddingX"
		)}
    py-${checkForOverride(
			baseTheme,
			cue.type,
			cue.preset,
			"background",
			"paddingY"
		)}
    text-${checkForOverride(baseTheme, cue.type, cue.preset, "h1", "size")}
    leading-${checkForOverride(
			baseTheme,
			cue.type,
			cue.preset,
			"h1",
			"leading"
		)}
    rounded-${checkForOverride(
			baseTheme,
			cue.type,
			cue.preset,
			"background",
			"rounding"
		)}
    
`}
				>
					<ReplaceWithDataSource text={cue.body} styled={true} />
				</span>
				{/* IMAGE */}
				<img
					alt="graphic"
					src={`${mediaLocation}${cloud ? cue.url : cue.filename}`}
					style={{
						backgroundRepeat: "no-repeat",
						objectFit: cue.backgroundFit || "cover",

						backgroundPosition: "center",
					}}
					className={`image_key flex
        
        w-s7
        h-s7
        rounded-${checkForOverride(
					baseTheme,
					cue.type,
					cue.preset,
					"background",
					"rounding"
				)}
        
    `}
				/>
			</span>
		</>
	);
}
